import { h } from 'preact';

import SectionDivider from '../../../components/3-molecules/section-divider/section-divider';

export const renderHeading = (data) => (
  <SectionDivider modifiers={['sky-it']} title={data.title} description={data.subtitle} />
);
